/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Clipboard from "clipboard";
import axios from "axios";
import { base_url } from "../../../base_urls";
import SearchBar from "../Ft-intro/SearchBar";
const MassAiPrompts = () => {
  const [show, setShow] = useState(false);
  const [scnd, setScnd] = useState(false);
  const [thrd, setThrd] = useState(false);
  const [fourth, setFourth] = useState(false);
  const [fifth, setFifth] = useState(false);

  const [prompts, setPrompts] = useState([]);

  useEffect(() => {
    axios
      .get(base_url + "api/aiAnalysisSamples/massAiPrompts.json")
      .then((res) => setPrompts(res.data))
      .catch((err) => console.log(err));
  }, []);
  console.log("prompts: ", prompts);
  const handleShow = () => {
    setShow(!show);
  };
  const handleShowscnd = () => {
    setScnd(!scnd);
  };

  const showThrd = () => {
    setThrd(!thrd);
  };
  const showFourth = () => {
    setFourth(!fourth);
  };
  const showFifth = () => {
    setFifth(!fifth);
  };
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  useEffect(() => {
    const clipboard = new Clipboard(".clip-btn");

    clipboard.on("success", (e) => {
      e.trigger.textContent = "Copied!";
      setTimeout(() => {
        e.trigger.textContent = "Copy from Input";
      }, 2000);
      e.clearSelection();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    clipboard.on("error", (e) => {
      console.error("Copy failed", e);
    });

    return () => clipboard.destroy();
  }, []);
  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs maintitle="MassAi" title="الرئيسية" subtitle="MassAi" />
          {/* /Page Header */}
          <div className="row mb-4">
            <SearchBar />
          </div>
          <div className="row card mt-4">
            <div className="card-header d-flex justify-content-start gap-3">
              <h3 className=" text-center text-primary mt-2">جرب - MassAi</h3>
              <h2 className="card-title mt-2">
                {" "}
                يمكنك استعمال الاسئلة الموجودة لتجربة MassAi{" "}
              </h2>
            </div>

            <div className="card-body">
              <div className="faq-card prompts-card">
                <p className="text-primary mb-4 me-4">
                  بعض الاسئلة على الفئات المهمة في النظام الذكي{" "}
                </p>
                {Object.entries(prompts).map(([category, items], index) => (
                  <div className="card mb-3 rounded-3" key={index}>
                    <div className="card-header ">
                      <h4 className="card-title">
                        <Link
                          className={activeIndex === index ? "" : "collapsed"}
                          aria-expanded={activeIndex === index}
                          data-bs-toggle="collapse"
                          to="#"
                          onClick={() => handleToggle(index)}
                        >
                          {category}
                        </Link>
                      </h4>
                    </div>
                    <div
                      className={`card-body card-collapse collapse ${
                        activeIndex === index ? "show" : ""
                      }`}
                    >
                      {items.map((prompt, i) => (
                        <div className="clipboard copy-txt mb-3" key={i}>
                          <p className="fw-bold text-primary">
                            Prompt (English):
                          </p>
                          <p className="otp-pass" id={`en-copy-${index}-${i}`}>
                            {prompt.en}
                          </p>
                          <p className="fw-bold text-primary">
                            السؤال (بالعربية):
                          </p>
                          <p className="otp-pass" id={`ar-copy-${index}-${i}`}>
                            {prompt.ar}
                          </p>
                          <div className="d-flex gap-2 mb-4">
                            <button
                              className="btn btn-sm btn-outline-primary clip-btn"
                              data-clipboard-action="copy"
                              data-clipboard-target={`#en-copy-${index}-${i}`}
                            >
                              <i className="far fa-copy" /> Copy English
                            </button>
                            <button
                              className="btn btn-sm btn-outline-success clip-btn"
                              data-clipboard-action="copy"
                              data-clipboard-target={`#ar-copy-${index}-${i}`}
                            >
                              <i className="far fa-copy" /> نسخ بالعربية
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
};

export default MassAiPrompts;
